import * as React from "react";
import NavBar from "./serviceRequest/srScreens/navbar";
import SRContainer from "./serviceRequest/srScreens/srContainer";
import moment from "moment";
import { getAccData } from "../service/login/loginService";
import {
  asyncGetPersonalDetails,
  asyncGetMessageDetails,
  asyncGetServiceRequest,
} from "../service/postLogin/clientProfileAPIService";
import Loader from "../generic/loader";
import EdModal from "../generic/edModal";
import { FinalPopupScreen } from "./generic/finalPopupScreeen";
import urlConfig, { config } from "../../config/domain";
import {
  CreateServiceRequestDetails,
  GetEsignStatus,
  getEsignStatusJMW,
  getloginDataforApp,
  getMemorandumDetails,
  ServiceClientValidation,
  updateAccReactStatus,
} from "../service/serviceRequest/srApiService";
import { setInterval } from "timers";
import { Idevice } from "../types/device";
import DeviceContext from "../service/indentifyDevice";
import { ClevertapService } from "../service/clevertapService";
import { NetcoreService } from "../service/netcoreService";
import { GetNameDOBValidation } from "../service/generic/otherApi";
import { apiService } from "../service/apiService";
import {getinvAccDet} from "../service/login/loginService"
 let invOnlyAcc = getinvAccDet();

const device: Idevice = DeviceContext();
const clevertapService = new ClevertapService();
const netcoreService = new NetcoreService();
const statusList: any = {
  emailMob: invOnlyAcc ? "We have received your request. Status of your request will be communicated through email":
    "Your request will be updated within TWO working days. Status of your request will be communicated through Email",
  bank: invOnlyAcc ? "We have received your request. Status of your request will be communicated through email":
  "Your request will be updated within TWO working days. Status of your request will be communicated through Email",
  address: invOnlyAcc ? "We have received your request. Status of your request will be communicated through email":
    "Your request will be updated within TWO working days. Status of your request will be communicated through Email",
  accReact:
    "Your request will be updated within FIVE working days. Status of your request will be communicated through Email",
  accReactPay: 
    "Your request will be updated within FIVE working days. Status of your request will be communicated through Email",
  nomination: invOnlyAcc ? "We have received your request. Status of your request will be communicated through email":
    "Your request will be updated within TWO working days. Status of your request will be communicated through Email",
  outstandingMsg: "We are verifying your Esign details.",
  accClosure: 
    "Your request will be updated within 3 working days. Status of your request will be communicated through Email.",
  ddpi: 
  "Your request has been received. We may take upto 2 days to update your accounts",
};

class ClientAreaCtrl extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoggedIn: false,
      serviceReq: [],
      profile: {},
      messages: [],
      accData: {},
      accList: [],
      outstanding: false,
      showStatusPopup: false,
      refID: "",
      intervalId: "5sec",
    };
  }

  async componentDidMount() {
    //this.getAccData();
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (
      params.source &&
      params.hasOwnProperty("appID") &&
      params.mod &&
      params.mod === "accReact"
    ) {
      var intervalId = setInterval(async () => {
        if (this.state.intervalId) this.initialCall(params);
      }, 2000);

      this.setState({ intervalId });
    } else this.initialCall(params);
  }
  // getAccData = async() => {
  //   let resp = await getloginDataforApp();
  
  //   if(resp?.data)
  //   window.localStorage.setItem("acc_data", JSON.stringify(resp?.data?.lgnData))
  // }
   getLoginDataCallback = (res : any) => {
    
    if(res && res.data) {
      window.localStorage.setItem("acc_data", JSON.stringify(res?.data?.lgnData))
      }      
     }
  initialCall = async (params: any) => {
    let isStatusUpdated = false;
    const serviceReq = await asyncGetServiceRequest();
    window.sessionStorage.setItem("serviceReqList",JSON.stringify(serviceReq));
    // const nameDOBValidation = await GetNameDOBValidation();

    // if(nameDOBValidation && nameDOBValidation.validationStatus) {
    //    window.sessionStorage.setItem("nameDOBValidation", nameDOBValidation.validationStatus);
    //    if(nameDOBValidation.result[0] && nameDOBValidation.result[0].data) {
    //        window.sessionStorage.setItem("nameDOBMismatch", nameDOBValidation.result[0].data.nameMsg.toLowerCase() !== "matched with database" && nameDOBValidation.result[0].data.dobMsg.toLowerCase() !== "matched with database"? "nameanddob": nameDOBValidation.result[0].data.nameMsg.toLowerCase() == "matched with database" ? nameDOBValidation.result[0].data.dobMsg.toLowerCase() == "matched with database" ? "" : "dob" : "name");
    //    }
    // }

    if((window.localStorage.getItem("lgnSrc") === "android-phone" || window.localStorage.getItem("lgnSrc") === "iphone") && window.location.href.includes("account-reactivation") ) {   //Check for account reactivation flow through mobile app
    
        const payload = {
          requestType: "Account Reactivation",
          dpID: "None",
        };
        let response = await ServiceClientValidation({
          subType: "Equity Dormant Reactivation",
        });
        const sr = serviceReq.filter(
          (srReq: any) =>
            srReq.RequestType === "Equity Dormant Reactivation" &&
            [
              "Draft Saved",
              "Submitted",
              "AssignedtoHO",
              "InProcess",
              "PendingforEsign",
              "EsignVerified",
              "EsignSubmitted",
              "AssignedforEsignQC",
              "EsignVerified",
              "PushToTarget",
              "MemorandumPaymentPending",
            ].includes(srReq.RequestStatus)
        )[0];
        if (response === "BOAcoountNumber not found") {
          const accReact = await CreateServiceRequestDetails(payload);
          // if (
          //   typeof accReact === "string" &&
          //   accReact.includes(
          //     "Previous Request already open for this account-"
          //   )
  
          // ) {
          //   setLoader(false);
          //   setError(true);
          //   return;
          // }
          
          if (accReact)
            localStorage.setItem(
              "accReactParentDetails",
              JSON.stringify(accReact)
            );
        } else {
          if (sr)
            localStorage.setItem("accReactParentDetails", JSON.stringify(sr));
        }
    }

    if (params.source && params.hasOwnProperty("appID") && params.mod) {
      if (params.mod === "accReact") {
        let resTotalNet = await getMemorandumDetails();
        const sr = serviceReq.filter(
          (srReq: any) =>
            srReq.RequestType === "Equity Dormant Reactivation" &&
            (srReq.RequestStatus === "EsignVerified" ||
              srReq.RequestStatus === "EsignSubmitted" ||
              srReq.RequestStatus === "QCPending")
        )[0];
        if (sr && sr.RequestId) {
          isStatusUpdated = true;
          this.setState({ intervalId: "" });
          clearInterval(this.state.intervalId);
        }
        const childServiceReq = await asyncGetServiceRequest(sr.RequestId);
        const ckyc = childServiceReq.find(
          (req: any) => req.RequestType === "CKYC Update"
        );

        let reqObj: any = {
          dormant_type: sr.dormant_type,
          parent_id: sr.RequestId,
        };

        if (sr) {
          if (sr.dormant_type === "1") {
            reqObj = {
              ...reqObj,
              ckycSRId: ckyc?.RequestId ? ckyc.RequestId : 0,
              ckycStatus: ckyc?.RequestStatus ? ckyc.RequestStatus : "None",
              requestType: "UpdateMemorandum",
            };
            if (
              resTotalNet.result &&
              Number(resTotalNet.result[0].Total_NET_Outstanding) > 0
            ) {
              this.setState({ outstanding: true });
            }
          }
          if (
            sr.dormant_type === "1" &&
            resTotalNet.result &&
            Number(resTotalNet.result[0].Total_NET_Outstanding) > 0
          ) {
            if (["EsignVerified"].includes(sr.RequestStatus)) {
              return this.props.history.push(
                "service-request/account-reactivation"
              );
            } else {
              const sr = serviceReq.filter(
                (srReq: any) =>
                  srReq.RequestId ===
                  String(atob(window.location.href.split("appID=")[1]))
              )[0];
              await this.redirectToPopup(sr.EsignRefId);
              // this.setState({ showStatusPopup: true });
            }
          } else {
            if (
              ["EsignVerified"].includes(sr.RequestStatus) ||
              ["QCPending"].includes(sr.RequestStatus)
            ) {
              updateAccReactStatus(reqObj)
                .then(async (res) => {
                  const serReq = serviceReq.filter(
                    (srReq: any) =>
                      srReq.RequestId ===
                      String(atob(window.location.href.split("appID=")[1]))
                  )[0];
                  await this.redirectToPopup(serReq.EsignRefId);
                  // this.setState({ showStatusPopup: true });
                })
                .catch(async (err) => {
                  const serReq = serviceReq.filter(
                    (srReq: any) =>
                      srReq.RequestId ===
                      String(atob(window.location.href.split("appID=")[1]))
                  )[0];
                  await this.redirectToPopup(serReq.EsignRefId);
                  // this.setState({ showStatusPopup: true });
                });
            } else {
              const sr = serviceReq.filter(
                (srReq: any) =>
                  srReq.RequestId ===
                  String(atob(window.location.href.split("appID=")[1]))
              )[0];
              await this.redirectToPopup(sr.EsignRefId);
              // this.setState({ showStatusPopup: true });
            }
          }
        } else {
          await this.props.history.push("service-request");
        }
      } else if (params.mod === "nomination") {
        isStatusUpdated = true;
        let reqObj = { requestType: "NominationSuccess" };
        updateAccReactStatus(reqObj)
          .then(async (res) => {
            const sr = serviceReq.filter(
              (srReq: any) =>
                srReq.RequestId ===
                String(atob(window.location.href.split("appID=")[1]))
            )[0];
            await this.redirectToPopup(sr.EsignRefId);
            // this.setState({ showStatusPopup: true });
          })
          .catch(async (err) => {
            const sr = serviceReq.filter(
              (srReq: any) =>
                srReq.RequestId ===
                String(atob(window.location.href.split("appID=")[1]))
            )[0];
            await this.redirectToPopup(sr.EsignRefId);
            // this.setState({ showStatusPopup: true });
          });
      } else if (params.mod === "accReactPay") {
        const sr = serviceReq.filter(
          (srReq: any) =>
            srReq.RequestId ===
            String(atob(window.location.href.split("appID=")[1]))
        )[0];
        isStatusUpdated = true;
        await this.redirectToPopup(sr.EsignRefId);
      } else {
        console.log(
          'String(atob(window.location.href.split("appID=")[1]))',
          String(atob(window.location.href.split("appID=")[1]))
        );

        const sr = serviceReq.filter(
          (srReq: any) =>
            srReq.RequestId ===
            String(atob(window.location.href.split("appID=")[1]))
        )[0];
        isStatusUpdated = true;
        // console.log("sr", sr);
        await this.redirectToPopup(sr.EsignRefId);
      }
    } else isStatusUpdated = true;

    if (isStatusUpdated) {
      const message = await asyncGetMessageDetails();
      const profile = await asyncGetPersonalDetails();
      const accData = await getAccData();
      if(profile) {
        window.sessionStorage.setItem("mobile",profile.mobileNumberField);
        window.sessionStorage.setItem("email",profile.emailAddressField)
      }
      var accList = "";
      if (localStorage.getItem("AccList")) {
        var acntLst = localStorage.getItem("AccList") || "";
        accList = JSON.parse(acntLst);
      }
      this.setState({
        serviceReq: serviceReq.length > 0 ? serviceReq.reverse() : [],
        message,
        profile,
        accData,
        accList,
      });
      this.setState({ serviceReq, message, profile, accData, accList });
    }
  };

  triggerClvrTap = (type: string) => {
    var data = {
      EventName: "Successful_SR",
      InitiationElement: "SrClientArea_Popup_Close",
      InitiationScreen: window.location.pathname,
      LoginType: "Traditional",
      SrType: type?.replace(" ", "_"),
      currentTime: moment().format("DD/MM/YYYY HH:mm:ss"),
      Platform: window.localStorage.getItem("lgnSrc")
        ? window.localStorage.getItem("lgnSrc")
        : device.isMobile
        ? "Website_Mobile"
        : "Website_Desktop",
    };
    var attributesList = {
      event_name: "successful_sr",
      initiation_element: "SrClientArea_Popup_Close",
      initiation_screen: window.location.pathname,
      login_type: "Traditional",
      sr_type: type?.replace(" ", "_"),
      current_time: moment().format("DD/MM/YYYY HH:mm:ss"),
      platform: window.localStorage.getItem("lgnSrc")
        ? window.localStorage.getItem("lgnSrc")
        : device.isMobile
        ? "Website_Mobile"
        : "Website_Desktop",
    };
    clevertapService.pushEvent(data);
    netcoreService.netcoreEventFire(attributesList.event_name, attributesList);
  };
  redirectToDash = () => {
    window.location.href = window.location.href.includes("source=nsdl_onep")
      ? config.onePlatformBase + "service-request"
      : config.rootUrl + "clientarea/servicerequest";
      
  };

  redirectToPopup = async (refId: any) => {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params.mod === "accClosure") {
      if (refId) {
        // console.log("inside.............");

        let res = await getEsignStatusJMW(refId);

        if (
          res.data &&
          JSON.parse(res.data.value).Data.status === "COMPLETED"
        ) {
          this.setState({ showStatusPopup: true });
          this.setState({ refID: refId });
        } else {
          this.redirectToDash();
        }
      } else {
        this.redirectToDash();
      }
    } else {
      if (refId) {
        let res = await GetEsignStatus(refId);
        if (res.Data.status === "COMPLETED") {
          this.setState({ showStatusPopup: true });
          this.setState({ refID: refId });
        } else {
          this.redirectToDash();
        }
      } else {
        this.redirectToDash();
      }
    }
  };

  render() {
    const {
      serviceReq,
      message,
      profile,
      accData,
      accList,
      showStatusPopup,
    }: any = this.state;

    const StatusPopup = () => {
      return (
        <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup">
          <div className="modal-content top-brdr-block">
            <div className="modal-body">
              <div>
                <a
                  role="button"
                  href={
                    window.location.href.includes("source=nsdl_ajs") ||
                    window.location.href.includes("source=ajs")
                      ? config.rootUrl + "clientarea/servicerequest"
                      : config.onePlatformBase + "service-request"
                  }
                  onClick={() => {
                    this.triggerClvrTap(
                      window.location.href.split("&")[0].split("mod=")[1]
                    );
                  }}
                  title="Close"
                  className="cancel"
                >
                  <i className="edel-icon-close"></i>
                </a>
              </div>
              <div>
                <FinalPopupScreen
                  popupData={{
                    headerText: "We have received your request!",
                    content:
                      statusList[
                        this.state.outstanding
                          ? "outstandingMsg"
                          : window.location.href.split("&")[0].split("mod=")[1]
                      ],
                    btnText:
                      window.location.href.split("&")[0].split("mod=")[1] ===
                      "ddpi"
                        ? "Download E-Signed DDPI Form"
                        : window.location.href.includes("nomination")
                      ? "Download Pre-filled Form"
                        : window.location.href
                            .split("&")[0]
                            .split("mod=")[1] === "address" ||
                          window.location.href
                            .split("&")[0]
                            .split("mod=")[1] === "bank"
                        ? "Download E-Signed Form for your reference"
                        : "Download E-Signed Form",
                    type: window.location.href.includes("nomination") ? "nomination" : window.location.href.split("&")[0].split("mod=")[1],
                    popupType: "Success",
                    refId: this.state.refID ? this.state.refID : "",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <>
        <div className="serviceRequest_container">
          <NavBar
            serviceReq={serviceReq.length}
            message={message ? message.length : 0}
          />
          <div className="serviceRequest_cardWrap">
            <div className="">
              {accData.accTyp ? (
                <SRContainer
                  accType={accData.accTyp}
                  serviceReq={serviceReq}
                  accList={accList}
                  profile={profile}
                />
              ) : (
                <div style={{ textAlign: "center", paddingTop: "50px" }}>
                  <Loader size={50} color="blue"></Loader>
                </div>
              )}
            </div>
          </div>
        </div>
        <EdModal
          show={showStatusPopup}
          close={() => {}}
          children={StatusPopup()}
        />
      </>
    );
  }
}

export default ClientAreaCtrl;
